import { apiEndpoints, CommandResult, PortalLoginOptions, PortalSharedDocumentView, PortalSharedResourceSpec, PortalSharedResourceView, PortalSharedSurveyReportView, SharedSurveyReport } from '../amorg-common';
import { commandAuthWrapper, queryAuthWrapper } from './serverApiHelpers';

export const portalClientApi = {

    getLoginOptions: async (siteId: string): Promise<PortalLoginOptions> =>
        await queryAuthWrapper(apiEndpoints.portal_login_siteId_options.replace(':siteId', siteId)),

    requestMagicLink: async (siteIdOrLoginName:string, email:string): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_login_siteId_magicLink_request.replace(':siteIdOrLoginName', siteIdOrLoginName), 'POST',
            { email }),

    confirmMagicLink: async (siteId:string, email:string, requestId:string): Promise<boolean> =>
    {
         const response = await fetch(apiEndpoints.portal_login_siteId_magicLink_confirm.replace(':siteId', siteId).replace(':email', email).replace(':requestId', requestId),
            {
                method:'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.status === 200;
    },

    sharePortalResource: async (id: string, resourceId: string, spec: PortalSharedResourceSpec): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_shared_resources, 'POST', { id, resourceId, spec }),

    unsharePortalResource: async (id: string): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_shared_resources_id.replace(':id', id), 'DELETE'),

    getPortalSharedResources: async (): Promise<PortalSharedResourceView[]> =>
        await queryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[],

    getPortalFiles: async (): Promise<PortalSharedDocumentView[]> =>
    {
        const resources = await queryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[];
        return resources
            .filter(resource => resource.resourceType === 'DocumentArchiveFile')
            .map(resource => ({
                ...resource,
                created: new Date(resource.created)
            }));
    },

    getPortalSurveyReports: async (surveyId:string): Promise<PortalSharedSurveyReportView[]> =>
    {
        const resources = await queryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[];
        return resources
            .filter(resource => resource.resourceType === 'SurveyReport' && resource.resourceId === surveyId)
            .map(resource => ({
                ...resource,
            }) as PortalSharedSurveyReportView);
    },

    getPortalSurveyReport: async (resourceId:string): Promise<SharedSurveyReport | null> =>
    {
        return await queryAuthWrapper(apiEndpoints.portal_shared_survey_report.replace(':portalResourceId', resourceId)) as SharedSurveyReport | null;
    },

    accessKeyLogin: async (siteId:string, accessKey:string): Promise<boolean> =>
    {
         const response = await fetch(apiEndpoints.portal_access_key_siteId_accessKey.replace(':siteId', siteId).replace(':accessKey', accessKey),
            {
                method:'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.status === 200;
    }
}